










































































































import { BreadCrumb, globalStore } from "@/store/modules/GlobalStore";
import { Component } from "vue-property-decorator";
import BasePage from "../base/BasePage";
import { AccountService } from "@/services/AccountService";
import { NullableString } from "@/code/Types";

@Component
export default class extends BasePage {
  title = " ";
  breadCrumbs = [new BreadCrumb("/")];

  accountService = new AccountService();

  email: NullableString = null;
  otp: NullableString = null;
  sentOtp = false;
  loginError = false;
  otpEmail: NullableString = null;
  isProcessRunning = false;

  get supportEmail(): string {
    return "support@thepalladiumgrp.com";
  }

  created(): void {
    globalStore.setWelcomeBackFlag(true);
  }
}
